import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image"
import { Swiper, SwiperSlide } from "swiper/react"
import PropTypes from "prop-types"
import Layout from "../components/layout"
import SvgNext from "../components/svg/next"
import SvgPrev from "../components/svg/prev"
import SiteFooter from "../components/site-footer"
import SiteHeader from "../components/site-header"

const aboutQuery = graphql`
  query AboutQuery {
    slides: allFile(
      filter: { relativeDirectory: { eq: "images/about" } }
      sort: { order: ASC, fields: name }
    ) {
      edges {
        node {
          name
          childImageSharp {
            fixed(
              width: 800
              height: 1200
              cropFocus: CENTER
              fit: COVER
              jpegQuality: 70
            ) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
    allInstaNode(limit: 12, sort: { fields: [timestamp], order: DESC }) {
      edges {
        node {
          id
          mediaType
          localFile {
            childImageSharp {
              fluid(
                maxWidth: 600
                maxHeight: 600
                cropFocus: CENTER
                quality: 85
              ) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`

const SwiperPagination = ({ swiper }) => (
  <div className="absolute z-10 left-0 bottom-0 -mb-px">
    <div
      className="inline-block -mr-px p-4 lg:p-8 bg-baby-powder"
      onClick={() => swiper.slidePrev()}
    >
      <SvgPrev className="w-5 inline-block"></SvgPrev>
    </div>
    <div
      className="inline-block p-4 lg:p-8 bg-baby-powder"
      onClick={() => swiper.slideNext()}
    >
      <SvgNext className="w-5 inline-block"></SvgNext>
    </div>
  </div>
)

const Profile = ({ slides }) => {
  const [swiper, setSwiper] = useState(null)
  const styleSwiperContainer = {
    width: "100%",
    height: "100%",
  }
  return (
    <div className="relative">
      <Swiper
        style={styleSwiperContainer}
        onSwiper={setSwiper}
        loop
        slidesPerView="auto"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <img
              className="w-full"
              srcSet={slide.fixed.srcSet}
              src={slide.fixed.src}
              alt={slide.title}
            ></img>
          </SwiperSlide>
        ))}
        {swiper && <SwiperPagination swiper={swiper}></SwiperPagination>}
      </Swiper>
    </div>
  )
}

const AboutMe = () => (
  <>
    <h2 className="h2">Kia Ora</h2>
    <div className="rte">
      <p>
        My career has started in a security company as a stock trader and
        adviser even my <strong>major was in IT</strong>. I've learned C at Uni
        and always <strong>have a heart for programming</strong>. Therefore I
        applied IT professional position at the same company. After passed the
        test and got the job, I've started to{" "}
        <strong>built things around the web</strong> and maintained company's
        computer server.
      </p>
      <p>
        6 years ago, I came to New Zealand to study Multimedia primarily for the
        web. <strong>Self taught</strong> all the modern{" "}
        <strong>web technologies</strong> that I am using to build products for
        you. Thanks for people whom keep betting on the web that make me feel
        like a 10x developer somehow and yep, it's wonderful thing. Thus, I've
        devoted my career onto it and keep betting on it.
      </p>
      <p>
        <strong>Digital Designer</strong>. Part time. I <strong>enjoy</strong>{" "}
        playing around with <strong>fonts and UI/UX</strong> just like watching
        a good movie.
      </p>
    </div>
  </>
)

const AboutPage = ({ location }) => {
  const { slides, allInstaNode } = useStaticQuery(aboutQuery)
  const instaList = allInstaNode.edges
    .map(({ node }) => ({
      id: node.id,
      image: node.localFile?.childImageSharp,
      mediaType: node.mediaType || "GraphImage",
    }))
    .filter((item) => !!item.image)
  return (
    <Layout location={location}>
      <SiteHeader location={location}></SiteHeader>
      <div className="main">
        <div className="body section lg:flex flex-no-wrap">
          <div className="lg:flex-1">
            <Profile
              slides={slides.edges.map(({ node }) => ({
                ...node.childImageSharp,
                title: node.name,
              }))}
            ></Profile>
          </div>
          <div className="pt-16 pl-0 lg:py-0 lg:flex-1 lg:pl-8">
            <AboutMe></AboutMe>
          </div>
        </div>
        <div className="body section">
          <div className="mb-6">
            <h2 className="h2">Things Around Me</h2>
          </div>
          <div className="flex flex-wrap overflow-hidden">
            {instaList.map((insta) => (
              <div
                className="w-1/2 lg:w-1/3 xl:w-1/4 overflow-hidden"
                key={insta.id}
              >
                <Image {...insta.image}></Image>
              </div>
            ))}
          </div>
        </div>
      </div>
      <SiteFooter></SiteFooter>
    </Layout>
  )
}

AboutPage.propTypes = {
  location: PropTypes.object.isRequired,
}

export default AboutPage
